import { resolveMenuRoute } from '@/utils/sidebarRouteResolver'

/**
 * 侧栏 / menuNav 子菜单卡片树工具（支持多级：父级卡片 → 子级卡片 → 功能页）。
 */

export function findMenuNodeInTree (nodes, id) {
  if (!Array.isArray(nodes) || id == null) return null
  const want = Number(id)
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (Number(n.id) === want) return n
    const hit = findMenuNodeInTree(n.menuList, id)
    if (hit) return hit
  }
  return null
}

export function findMenuParentChain (nodes, id, chain = []) {
  if (!Array.isArray(nodes) || id == null) return null
  const want = Number(id)
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (Number(n.id) === want) return chain
    if (Array.isArray(n.menuList) && n.menuList.length) {
      const hit = findMenuParentChain(n.menuList, id, chain.concat(n))
      if (hit) return hit
    }
  }
  return null
}

export function menuHasNavChildren (menu) {
  return !!(menu && Array.isArray(menu.menuList) && menu.menuList.length)
}

export function collectLeafMenuTitles (menu, limit, titleOf) {
  const out = []
  const walk = (node) => {
    if (!node || out.length >= limit) return
    const children = Array.isArray(node.menuList) ? node.menuList : []
    if (!children.length) {
      const t = titleOf(node)
      if (t) out.push(t)
      return
    }
    for (let i = 0; i < children.length; i++) {
      if (out.length >= limit) break
      walk(children[i])
    }
  }
  walk(menu)
  return out
}

export function buildMenuNavCardDesc (menu, dynamicMenuRoutes, resolveMenuRoute, titleOf) {
  if (menuHasNavChildren(menu)) {
    const names = collectLeafMenuTitles(menu, 3, titleOf)
    return names.length ? names.join(' / ') : '查看子選單'
  }
  const route = resolveMenuRoute(dynamicMenuRoutes, menu)
  if (route && route.meta && route.meta.title) return route.meta.title
  return '進入此功能頁面'
}

export function collectLeafMenus (menu, out = []) {
  if (!menu) return out
  const children = Array.isArray(menu.menuList) ? menu.menuList : []
  if (!children.length) {
    out.push(menu)
    return out
  }
  for (let i = 0; i < children.length; i++) collectLeafMenus(children[i], out)
  return out
}

/** 目錄／分組卡片：向下找第一個可解析路由（與 home 首頁卡片一致） */
export function findFirstRouteByMenu (menu, dynamicMenuRoutes, resolveMenuRouteFn) {
  const resolveFn = resolveMenuRouteFn || resolveMenuRoute
  if (menu && menu.url && /\S/.test(String(menu.url))) {
    const selfRoute = resolveFn(dynamicMenuRoutes, menu)
    if (selfRoute && selfRoute.name) return selfRoute
  }
  const leaves = collectLeafMenus(menu)
  for (let i = 0; i < leaves.length; i++) {
    const route = resolveFn(dynamicMenuRoutes, leaves[i])
    if (route && route.name) return route
  }
  return null
}



// WEBPACK FOOTER //
// ./src/utils/menuNavTree.js